/*
 * @Author: Hong.Zhang
 * @Date: 2024-11-22 15:15:51
 * @Description:
 */
export const WHATS_APP_LINK =
  'https://api.whatsapp.com/send/?phone=%2B6287766860381&text&type=phone_number&app_absent=0';

export const TRAVEL_DOMESTIC_POLICY_WORDING =
  'https://static.iglooinsure.com/vertical/b2b/kredivo/policy_wording_travel_domestic.pdf';

export const ZURICH_SYARIAH_PA_POLICY_WORDING =
  'https://static.iglooinsure.com/vertical/b2b/kredivo/policy_wording_zurich_syariah_pa.pdf';

export const PA_HOSPITAL_CASH_POLICY_WORDING =
  'https://static.iglooinsure.com/vertical/b2b/kredivo/policy_wording_pa_hospital_cash_rev4.pdf';

export const PA_HOME_PROTECTION_POLICY_WORDING =
  'https://static.iglooinsure.com/vertical/b2b/kredivo/policy_wording_pa_home_protection_rev3.pdf';

export const MOTOLITE_POLICY_WORDING =
  'https://static.iglooinsure.com/vertical/b2b/kredivo/policy_wording_motolite.pdf';

export const KREDIVO_HOME_PAGE = 'kredivo://deeplink/dashboard';

export const INSURANCE_ENTITY = {
  POLICYHOLDER: 'policyholder',
  INSURED: 'insured',
  SOI: 'soi',
};

export const PERSON_TYPES = {
  ADULT: 'adult',
  UNDERAGE: 'underage',
};

export const SOURCE_TYPES = {
  PROVINCE: 'province',
  CITY: 'city',
  TRAVEL_CITY: 'travel_city',
  GENDER: 'gender',
  RELATIONSHIP: 'relationship',
  MOTORCYCLE_BRAND: 'motorcycle_brand',
  MOTORCYCLE_MODEL: 'motorcycle_model',
  MOTORCYCLE_MANUFACTURE_YEAR: 'motorcycle_manufacture_year',
};

export const SOURCE_TYPE_2_DATASET_KEY = {
  [SOURCE_TYPES.PROVINCE]: '3e727dfc-d10f-4573-b965-809473add170',
  [SOURCE_TYPES.CITY]: 'a504789f-4083-46a0-a714-81d6fa9fe43f',
  [SOURCE_TYPES.TRAVEL_CITY]: 'e165cc8b-4740-4be7-b948-1197a20bb992',
  [SOURCE_TYPES.GENDER]: '0a0fd160-9ffb-43c2-bddd-ab38cbdef626',
  [SOURCE_TYPES.RELATIONSHIP]: 'ae0602ae-1c79-476b-a1ee-9de3ea35ef3f',
  [SOURCE_TYPES.MOTORCYCLE_BRAND]: '4f8e6600-fe90-42cc-bd0c-7c5efa20f6f9',
  [SOURCE_TYPES.MOTORCYCLE_MODEL]: 'dc42ac5d-f3bc-41bb-a781-dc2b31c33c74',
  [SOURCE_TYPES.MOTORCYCLE_MANUFACTURE_YEAR]: '47129c7f-c309-4c83-b6e4-646ad45e5bf6',
};

export const AREA_CODE = '62';

export const TERMS_OF_SERVICE =
  'https://static.iglooinsure.com/vertical/b2b/kredivo/terms_of_service.pdf';

export const PRIVACY_POLICY =
  'https://static.iglooinsure.com/vertical/b2b/kredivo/privacy_policy.pdf';

export const AGE_RANGE_TRAVEL_DOMESTIC = [18, 70];
export const AGE_RANGE_ZURICH_SYARIAH_PA = [16, 65];
export const AGE_RANGE_PA_HOSPITAL_CASH = [17, 60];
export const AGE_RANGE_PA_HOME_PROTECTION = [17, 60];
export const AGE_RANGE_MOTOLITE = [17, 60];

export const PDF_VIEWER_URL = 'https://pdf-viewer.iglooinsure.com';
// export const PDF_VIEWER_URL = 'https://docs.google.com';

export const ENABLE_HANDLE_401 = true;
